import { fundingKycScreen } from '@morfi/onramp-sdk';
import type { FundingCheckout } from '@morfi/onramp-sdk/react';

export function checkoutOwnsChrome(
  state: FundingCheckout['state'],
  verification: FundingCheckout['customerVerification'],
): boolean {
  if (
    state === 'methods' ||
    state === 'connection_required' ||
    state === 'unavailable' ||
    state === 'verification' ||
    state === 'status' ||
    state === 'profile'
  )
    return false;
  return !(
    state === 'customer_verification' &&
    verification &&
    fundingKycScreen(verification) === 'phone_verification'
  );
}
